function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface124953814"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,91.764706%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 10 6 C 7.8125 6 6 7.8125 6 10 L 6 38 C 6 40.1875 7.8125 42 10 42 L 38 42 C 40.1875 42 42 40.1875 42 38 L 42 24 L 38 24 L 38 38 L 10 38 L 10 10 L 24 10 L 24 6 Z M 28 6 L 28 10 L 35.171875 10 L 16.585938 28.585938 L 19.414062 31.414062 L 38 12.828125 L 38 20 L 42 20 L 42 6 Z M 28 6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.cbf37d3ebc4cbc85ff34a03f71b415f6.svg";
export { ForwardRef as ReactComponent };